import api from "../api/api";
class Logger {
  constructor() {
    this.correlationId = null;
  }

  setCorrelationId(id) {
    this.correlationId = id || crypto.randomUUID();
    // Also store in localStorage to persist across page reloads
    localStorage.setItem("correlationId", this.correlationId);
  }

  getCorrelationId() {
    if (!this.correlationId) {
      // Try to get from localStorage first
    const storedId = localStorage.getItem("correlationId");
    this.correlationId = storedId || "no correlation ID";
    }
    return this.correlationId;
  }

  async log(level, message, extra = {}) {
    const logData = {
      timestamp: new Date().toISOString(),
      level,
      message,
      correlation_id: this.getCorrelationId(),
      application: "react-frontend",
      ...extra,
    };

    // Console logging
    console[level](JSON.stringify(logData));

    // Send to backend
    if (
      process.env.REACT_APP_ENVIRONMENT === "production" &&
      logData.url &&
      logData.url !== "/logs/"
    ) {

      try {
        await api.post("/logs/", logData);
      } catch (error) {
        console.error("Failed to send log to Papertrail:", error);
      }
    }
  }

  info(message, extra = {}) {
    return this.log("info", message, extra);
  }

  error(message, error = null, extra = {}) {
    const errorData = {
      ...extra,
      error_message: error?.message,
      stack: error?.stack,
    };
    return this.log("error", message, errorData);
  }

  warn(message, extra = {}) {
    return this.log("warn", message, extra);
  }
}

export const logger = new Logger();
